import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Timezone = forwardRef<SVGSVGElement, SvgIconProps>(
  function Timezone(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12,1.5c-5.79136,0 -10.5,4.70864 -10.5,10.5c0,5.79136 4.70864,10.5 10.5,10.5c5.79136,0 10.5,-4.70864 10.5,-10.5c0,-5.79136 -4.70864,-10.5 -10.5,-10.5zm4.13346,13.39623c-0.1986,0.28755 -0.5086,0.44211 -0.84017,0.44211c-0.19861,0 -0.41965,-0.06649 -0.59667,-0.17702l-3.29324,-2.32105c-0.26509,-0.1986 -0.44211,-0.5086 -0.44211,-0.84018l0,-5.54886c0,-0.57509 0.46457,-1.03877 1.03877,-1.03877c0.5751,0 1.03877,0.46456 1.03877,1.03877l0,5.01767l2.85114,2.01194c0.46457,0.30998 0.57509,0.9507 0.24351,1.41524l0,0.00015z" />
      </SvgIcon>
    )
  },
)

export default Timezone
